import { render, staticRenderFns } from "./CascadingElementInCardTableColumn.vue?vue&type=template&id=cb4930d8"
import script from "./CascadingElementInCardTableColumn.vue?vue&type=script&lang=js"
export * from "./CascadingElementInCardTableColumn.vue?vue&type=script&lang=js"
import style0 from "./CascadingElementInCardTableColumn.vue?vue&type=style&index=0&id=cb4930d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports